import React, { FC, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronCircleDown,
  faChevronCircleUp,
} from '@fortawesome/free-solid-svg-icons';

import { useAutoApproval } from 'hooks/useAutoApproval';

import {
  Periodo,
  TableCourse,
  TableCourseT,
  TableRowHeader,
  TableRow,
  TableColumn,
  TableColumnCourses,
  TableRowTitle,
  Father,
  TableColumnTitleAlign,
  TableColumnTitleCourse,
  TableColumnTitle,
} from './styles';

interface CoursesList {
  course: {
    id: string;
    name: string;
    classShift: string;
    campus: string;
  };
}

const CoursesDetails: FC = () => {
  const [itsShowingCoursesDetails, toggleCoursesDetails] = useState(false);
  const { coursesTableList } = useAutoApproval();

  const toggleTable = (event) => {
    event.preventDefault();
    toggleCoursesDetails(!itsShowingCoursesDetails);
  };

  return (
    <Father>
      {!itsShowingCoursesDetails ? (
        <TableCourse>
          <TableRowTitle onClick={toggleTable}>
            <TableColumnTitleCourse>
              <label className="box-container-label-courses">Cursos:</label>
            </TableColumnTitleCourse>
            <TableColumnTitle>
              {coursesTableList.length > 1
                ? `${coursesTableList.length} cursos selecionados`
                : '1 curso selecionado'}
            </TableColumnTitle>
            <TableColumnTitleAlign>
              <FontAwesomeIcon
                icon={faChevronCircleDown}
                size="2x"
                color="#4A90E2"
              />
            </TableColumnTitleAlign>
            <hr />
          </TableRowTitle>
        </TableCourse>
      ) : (
        <TableCourseT>
          <TableRowTitle onClick={toggleTable}>
            <TableColumnTitleCourse>
              <label className="box-container-label-courses">Cursos:</label>
            </TableColumnTitleCourse>
            <TableColumnTitle>
              {coursesTableList.length > 1
                ? `${coursesTableList.length} cursos selecionados`
                : '1 curso selecionado'}
            </TableColumnTitle>
            <TableColumnTitleAlign>
              <FontAwesomeIcon
                icon={faChevronCircleUp}
                size="2x"
                color="#4A90E2"
              />
            </TableColumnTitleAlign>
            <hr />
          </TableRowTitle>

          <TableRowHeader>
            <TableColumnCourses>Cursos</TableColumnCourses>
            <TableColumn>Campus</TableColumn>
            <TableColumn>Limite de Vagas</TableColumn>
            <TableColumn>Qtde. vagas</TableColumn>
            <TableColumn>Percentual de crédito</TableColumn>
            <TableColumn>Valor mensalidade</TableColumn>
            <hr />
          </TableRowHeader>
          {coursesTableList.map((course) => {
            return (
              <TableRow key={course.id}>
                <TableColumnCourses>
                  {course.nome}
                  <Periodo>{course.turno}</Periodo>
                </TableColumnCourses>
                <TableColumn>{course.campus || ''}</TableColumn>
                <TableColumn>{course.limiteVagas || ''}</TableColumn>
                <TableColumn>{course.vagas || ''}</TableColumn>
                <TableColumn>
                  {course.percentual ? `${course.percentual}%` : ''}
                </TableColumn>
                <TableColumn>
                  {course.mensalidade ? `R$${course.mensalidade}` : ''}
                </TableColumn>
              </TableRow>
            );
          })}
        </TableCourseT>
      )}
      <hr />
    </Father>
  );
};

export default CoursesDetails;
